import React, { useState, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    // Lee del DOM directamente por si el autocompletar del navegador no disparó onChange
    const user = (usernameRef.current?.value || username).trim();
    const pass = passwordRef.current?.value || password;
    if (!user || !pass) {
      setError('Introduce usuario y contraseña');
      setLoading(false);
      return;
    }
    try {
      await login(user, pass);
    } catch (err) {
      setError(err.response?.data?.error || 'Usuario o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-mgh-blue-900 flex flex-col items-center justify-center p-4">
      {/* Logo */}
      <div className="mb-8 text-center">
        <div className="inline-flex items-center justify-center w-24 h-24 bg-mgh-yellow-400 rounded-3xl shadow-2xl mb-4">
          <span className="text-4xl font-black text-mgh-blue-900">MGH</span>
        </div>
        <h1 className="text-white text-2xl font-bold">MGH Electricidad</h1>
        <p className="text-blue-200 text-sm mt-1">Control de Jornada Laboral</p>
        <p className="text-blue-300 text-xs mt-0.5">Arganda del Rey, Madrid</p>
      </div>

      {/* Card */}
      <div className="w-full max-w-sm bg-white rounded-3xl shadow-2xl p-6">
        <h2 className="text-xl font-bold text-gray-800 mb-6 text-center">Iniciar Sesión</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="label">Usuario</label>
            <input
              ref={usernameRef}
              type="text"
              className="input text-base"
              placeholder="Tu nombre de usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoCapitalize="none"
              autoCorrect="off"
              autoComplete="username"
              required
            />
          </div>

          <div>
            <label className="label">Contraseña</label>
            <div className="relative">
              <input
                ref={passwordRef}
                type={showPass ? 'text' : 'password'}
                className="input text-base pr-10"
                placeholder="Tu contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                tabIndex={-1}
              >
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm text-center">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 bg-mgh-blue-900 text-white text-lg font-bold rounded-xl
                       hover:bg-mgh-blue-800 active:scale-95 transition-all
                       disabled:opacity-60 disabled:cursor-not-allowed mt-2"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Accediendo...
              </span>
            ) : (
              'Entrar'
            )}
          </button>
        </form>
      </div>

      <p className="text-blue-300 text-xs mt-6 text-center">
        RD-ley 8/2019 — Registro de jornada laboral
      </p>
    </div>
  );
}
